import { useEffect } from 'react';

export const useWindowEvent = (...parameters: Parameters<typeof window.addEventListener>) => {
  useEffect(() => {
    window.addEventListener(...parameters);

    return () => {
      window.removeEventListener(...parameters);
    };
  }, [parameters]);
};
